<div class="content dark">
	<app-expander #addExpander caption="Create a new note">
		<div class="form-group row">
			<label class="col-md-2">Title:</label>
			<div class="col-md-10">
				<input [(ngModel)]="newLog.editTitle" type="text" maxlength="64" class="form-control">
			</div>
		</div>
		<div class="form-group row">
			<div class="col-md-12">
				<div>Details:</div>
				<textarea [(ngModel)]="newLog.editContent" rows="10" class="form-control"></textarea>
			</div>
		</div>
		<div class="form-group row">
			<div class="col-md-8 offset-md-4">
				<app-action-button [action]="SaveLog" [context]="this" [args]="[newLog]" processing="Saving..." complete="Log saved" btnClass="btn-success btn-block">Save
				</app-action-button>
			</div>
		</div>
	</app-expander>
	<div *ngIf="adminLogs && adminLogs.length === 0">No notes for this asset</div>
	<table *ngIf="adminLogs && adminLogs.length > 0" class="log-table">
		<tbody>
			<tr>
				<th></th>
				<th>Date</th>
				<th>Entered by</th>
				<th>Summary</th>
				<th>Delete</th>
			</tr>
		</tbody>
		<tbody *ngFor="let log of adminLogs">
			<tr>
				<td (click)="log.expanded = !log.expanded" class="clickable"><span class="expander-button" [class.expanded]="log.expanded">▶</span></td>
				<td (click)="log.expanded = !log.expanded" class="clickable">{{log.ts | datetime : "date" }}</td>
				<td (click)="log.expanded = !log.expanded" class="clickable">{{log.author_email}}</td>
				<td (click)="log.expanded = !log.expanded" class="clickable truncate" [title]="log.title"><span>{{log.title}}</span></td>
				<td>
					<app-action-button [action]="DeleteLog" [args]="[log.admin_log_id]" [context]="this" btnClass="btn-danger btn-sm" confirm="Are you sure?" processing="...">x
					</app-action-button>
				</td>
			</tr>
			<tr *ngIf="log.expanded">
				<td colspan="5" class="log-content">
					<div class="form-group row">
						<label class="col-md-2">Title:</label>
						<div class="col-md-10">
							<input [(ngModel)]="log.editTitle" type="text" maxlength="64" class="form-control">
						</div>
					</div>
					<div class="form-group row">
						<div class="col-md-12">
							<div>Details:</div>
							<textarea [(ngModel)]="log.editContent" rows="10" class="form-control"></textarea>
						</div>
					</div>
					<div class="form-group row">
						<div class="col-md-8 offset-md-4">
							<app-action-button [action]="SaveLog" [context]="this" [args]="[log]" processing="Saving..." complete="Log saved" btnClass="btn-success btn-block">Save
							</app-action-button>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
</div>